import ContextProperty from 'owa-service/lib/contract/ContextProperty';
import FindPeopleRequest from 'owa-service/lib/contract/FindPeopleRequest';
import FindPeopleResponseMessage from 'owa-service/lib/contract/FindPeopleResponseMessage';
import IndexedPageView from 'owa-service/lib/contract/IndexedPageView';
import PersonaResponseShape from 'owa-service/lib/contract/PersonaResponseShape';
import SortResults from 'owa-service/lib/contract/SortResults';
import TargetFolderId from 'owa-service/lib/contract/TargetFolderId';
import contextProperty from 'owa-service/lib/factory/contextProperty';
import findPeopleJsonRequest from 'owa-service/lib/factory/findPeopleJsonRequest';
import findPeopleRequest from 'owa-service/lib/factory/findPeopleRequest';
import folderIdFactory from 'owa-service/lib/factory/folderId';
import indexedPageView from 'owa-service/lib/factory/indexedPageView';
import personaResponseShape from 'owa-service/lib/factory/personaResponseShape';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import sortResults from 'owa-service/lib/factory/sortResults';
import targetFolderId from 'owa-service/lib/factory/targetFolderId';
import findPeopleOperation from 'owa-service/lib/operation/findPeopleOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';

const MAX_ENTRIES_DEFAULT = 50;
const OFFSET_DEFAULT = 0;
const OWA_COMPOSE_SCENARIO_STRING = 'owa.react.compose';

function configureIndexedPageView(offset: number, maxEntries: number): IndexedPageView {
    return indexedPageView({
        BasePoint: 'Beginning',
        Offset: offset ? offset : OFFSET_DEFAULT,
        MaxEntriesReturned: maxEntries ? maxEntries : MAX_ENTRIES_DEFAULT,
    });
}

function configureParentFolderId(): TargetFolderId {
    return targetFolderId({
        BaseFolderId: folderIdFactory({
            Id: folderNameToId('mycontacts'),
        }),
    });
}

function configureSortOrder(): SortResults[] {
    let primarySort = sortResults({
        Order: 'Ascending',
        Path: propertyUri({ FieldURI: 'PersonaDisplayNameFirstLast' }),
    });

    return [primarySort];
}

function configurePersonaShape(): PersonaResponseShape {
    return personaResponseShape({
        BaseShape: 'Default',
    });
}

function configureRequestBody(offset: number, maxEntries: number): FindPeopleRequest {
    return findPeopleRequest({
        IndexedPageItemView: configureIndexedPageView(offset, maxEntries),
        ParentFolderId: configureParentFolderId(),
        PersonaShape: configurePersonaShape(),
        QueryString: null,
        SearchPeopleSuggestionIndex: false,
        ShouldResolveOneOffEmailAddress: false,
        SortOrder: configureSortOrder(),
        Context: configureContext(),
    });
}

function configureContext(): ContextProperty[] {
    return [
        contextProperty({ Key: 'AppName', Value: 'OWA' }),
        contextProperty({ Key: 'AppScenario', Value: OWA_COMPOSE_SCENARIO_STRING }),
    ];
}

export function findPeople(
    offset?: number,
    maxEntries?: number
): Promise<FindPeopleResponseMessage> {
    let requestBody = configureRequestBody(offset, maxEntries);
    return findPeopleOperation(
        findPeopleJsonRequest({
            Header: getJsonRequestHeader(),
            Body: requestBody,
        })
    ).then(response => {
        let responseMessage: FindPeopleResponseMessage = response.Body;
        return responseMessage;
    });
}
